var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#FDF1EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.265 21.8031C19.265 23.5712 17.8363 24.9992 16.0674 24.9992C14.2985 24.9992 12.8698 23.5712 12.8698 21.8031",
    stroke: "#EC5F2A",
    strokeWidth: 1.74611,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8877 7.00835C18.9853 7.00835 21.4985 9.50361 21.5152 12.5997L21.557 18.5333C21.557 18.8921 21.6989 19.2343 21.9577 19.4847L23.9699 21.5126C24.0534 21.596 23.995 21.7296 23.8781 21.7296L8.13114 21.6962C8.01425 21.6962 7.9558 21.5626 8.0393 21.4792L9.93461 19.5097C10.1851 19.251 10.3187 18.9088 10.3187 18.55L10.2602 12.6415C10.2602 9.52864 12.7734 7 15.8877 7V7.00835Z",
    stroke: "#EC5F2A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOrange);
export default __webpack_public_path__ + "static/media/notification-orange.7eac343b4e15d9a9176bded1f45a2526.svg";
export { ForwardRef as ReactComponent };